import { ISettings } from "../../typings/project";
import { inject } from "aurelia-framework";
import { EnvironmentVars } from 'environment';

@inject("appSettings")
export class ApplicationSettings{
    apiUrl: string;

    constructor(public readonly settings: ISettings) {
        this.apiUrl = EnvironmentVars.baseUrl;
    }    
}